<template>
  <div>
    <!-- 参会人列表对话框 -->
    <el-dialog
      title="转票"
      :visible.sync="listVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div v-loading="listLoading" class="transfer-ticket-list">
        <!-- 表头 -->
        <div class="transfer-ticket-header">
          <div class="header-cell" style="width: 100px;">姓名</div>
          <div class="header-cell" style="width: 80px;">性别</div>
          <div class="header-cell" style="width: 134px;">与报名者关系</div>
          <div class="header-cell" style="width: 216px;">身份证号码</div>
          <div class="header-cell" style="width: 150px;">手机号码</div>
          <div class="header-cell" style="width: 120px;">交通信息</div>
          <div class="header-cell" style="width: 180px;">登记时间</div>
          <div class="header-cell" style="width: 200px;">操作</div>
        </div>
        <!-- 表体 -->
        <div class="transfer-ticket-body">
          <div
            v-for="(row, index) in list"
            :key="index"
            class="transfer-ticket-row"
            :class="{ 'row-even': index % 2 === 1 }"
          >
            <div class="body-cell" style="width: 100px;">
              <div class="cell-content">
                <span class="name-info">{{ row.realName }}</span>
              </div>
            </div>
            <div class="body-cell" style="width: 80px;">
              <div class="cell-content">
                {{ row.sex === 1 ? "男" : row.sex === 2 ? "女" : "-" }}
              </div>
            </div>
            <div class="body-cell" style="width: 134px;">
              <div class="cell-content">{{ row.relationship || "-" }}</div>
            </div>
            <div class="body-cell" style="width: 216px;">
              <div class="cell-content">
                {{ row.idCardNo
                }}{{ row.isChild ? "(儿童)" : "(成人)" }}
              </div>
            </div>
            <div class="body-cell" style="width: 150px;">
              <div class="cell-content">{{ row.mobile}}</div>
            </div>
            <div class="body-cell" style="width: 120px;">
              <div class="cell-content">
                {{ row.isSubmitTransportation ? "已登记" : "未登记" }}
              </div>
            </div>
            <div class="body-cell" style="width: 180px;">
              <div class="cell-content">{{ row.operatedTime || "-" }}</div>
            </div>
            <div class="body-cell" style="width: 200px;">
              <div class="cell-content" v-if="row.relationship!='本人'">
                <el-button type="text" @click="handleTransfer(row)">
                  转票
                </el-button>
                <el-button type="text" @click="handleTransferRecord(row)">
                  转票记录
                </el-button>
              </div>
            </div>
          </div>
          <div v-if="list.length === 0" class="empty-data">暂无数据</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="listVisible = false">返回</el-button>
      </div>
    </el-dialog>

    <!-- 选择报名人弹窗（成人） -->
    <select-registrant-dialog
      :visible.sync="selectRegistrantVisible"
      :meeting-id="meetingId"
      :user-id="userId"
      :user-info-id="userInfoId"
      :user-type="userType"
      :phone="phone"
      :existing-registrants="[]"
      :max-carry-people="999"
      @confirm="handleSelectRegistrantConfirm"
      @close="handleSelectRegistrantClose"
    />

    <!-- 选择儿童弹窗 -->
    <select-child-dialog
      :visible.sync="selectChildVisible"
      :meeting-id="meetingId"
      :user-id="userId"
      :user-info-id="userInfoId"
      :user-type="userType"
      :max-carry-child-per="999"
      :existing-children="[]"
      @confirm="handleSelectChildConfirm"
      @close="handleSelectChildClose"
    />

    <!-- 转票记录对话框 -->
    <el-dialog
      title="转票记录"
      :visible.sync="recordVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div v-loading="recordLoading" class="transfer-record-list">
        <!-- 表头 -->
        <div class="transfer-record-header">
          <div class="header-cell" style="width: 200px;">原本参会人信息</div>
          <div class="header-cell" style="width: 180px;">转票时间</div>
          <div class="header-cell" style="flex: 1;">参会人信息</div>
        </div>
        <!-- 表体 -->
        <div class="transfer-record-body">
          <div
            v-for="(row, index) in recordList"
            :key="index"
            class="transfer-record-row"
            :class="{ 'row-even': index % 2 === 1 }"
          >
            <div class="body-cell" style="width: 200px;">
              <div class="cell-content">
                <div>
                  <span class="name-info">{{ row.oldRealName || "-" }}</span>
                </div>
                <div>{{ maskIdCard(row.oldIdCard) || "-" }}</div>
                <div>{{ maskMobile(row.oldMobile) || "-" }}</div>
              </div>
            </div>
            <div class="body-cell" style="width: 180px;">
              <div class="cell-content">{{ row.transferTime || "-" }}</div>
            </div>
            <div class="body-cell" style="flex: 1;">
              <div class="cell-content">
                <div>
                  <span class="name-info">{{ row.newRealName || "-" }}</span>
                </div>
                <div>{{ maskIdCard(row.newIdCard) || "-" }}</div>
                <div>{{ maskMobile(row.newMobile) || "-" }}</div>
              </div>
            </div>
          </div>
          <div v-if="recordList.length === 0" class="empty-data">
            暂无数据
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="recordVisible = false">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import meetingSignUpCarryPeopleApi from "@/api/meeting/meetingSignUpCarryPeople";
import meetingSignUpApi from "@/api/meeting/meetingSignUp";
import SelectRegistrantDialog from "./SelectRegistrantDialog.vue";
import SelectChildDialog from "./SelectChildDialog.vue";

export default {
  components: {
    SelectRegistrantDialog,
    SelectChildDialog
  },
  data() {
    return {
      listVisible: false,
      listLoading: false,
      list: [],
      currentRow: null,
      currentPersonName: "",
      signNo: null,
      meetingId: null,
      userId: null,
      userInfoId: null,
      userType: null,
      phone: "",
      selectRegistrantVisible: false,
      selectChildVisible: false,
      selectedPerson: null, // 选中的新参会人
      recordVisible: false,
      recordLoading: false,
      recordList: [],
      currentPersonId: null
    };
  },
  methods: {
    /**
     * 手机号脱敏处理
     */
    maskMobile(mobile) {
      if (!mobile) return "-";
      if (mobile.length === 11) {
        return mobile.substring(0, 3) + "****" + mobile.substring(7);
      } else if (mobile.length > 11) {
        const phonePart = mobile.substring(0, 11);
        const extraPart = mobile.substring(11);
        return (
          phonePart.substring(0, 3) +
          "****" +
          phonePart.substring(7) +
          extraPart
        );
      }
      return mobile;
    },
    /**
     * 身份证脱敏处理
     */
    maskIdCard(idCard) {
      if (!idCard) return "-";
      if (idCard.length >= 15) {
        return (
          idCard.substring(0, 3) +
          "***********" +
          idCard.substring(idCard.length - 4)
        );
      }
      return idCard;
    },
    /**
     * 打开转票列表页面
     */
    handleUpdate(row) {
      this.currentRow = row;
      this.signNo = row.signUpNo;
      // 从 row 中获取用户信息，用于传递给选择弹窗
      this.meetingId = row.meetingId || null;
      this.userId = row.userId || null;
      this.userInfoId = row.userInfoId || null;
      this.userType = row.userType || null;
      this.phone = row.userMobile || "";
      this.listVisible = true;
      this.loadList();
    },
    /**
     * 加载参会人列表
     */
    loadList() {
      if (!this.signNo) {
        this.$message.error("报名号不能为空");
        return;
      }
      this.listLoading = true;
      meetingSignUpCarryPeopleApi
        .fetchListTeev2({
          signNo: this.signNo,
          isGetTransportation: true
        })
        .then(res => {
          if (res && res.data) {
            this.list = res.data || [];
          } else {
            this.list = [];
          }
        })
        .catch(error => {
          this.$message.error(error.msg || "获取列表失败");
          this.list = [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 转票
     */
    handleTransfer(row) {
      this.currentRow = row;
      this.currentPersonName = row.realName;
      this.currentPersonId = row.id;
      this.selectedPerson = null;

      // 根据是否是儿童显示不同的弹窗
      if (row.isChild) {
        // 儿童：显示选择儿童弹窗
        this.selectChildVisible = true;
      } else {
        // 成人：显示选择报名人弹窗
        this.selectRegistrantVisible = true;
      }
    },
    /**
     * 选择报名人确认（成人）
     */
    handleSelectRegistrantConfirm(selectedRows) {
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning("请至少选择一个报名人");
        return;
      }
      // 转票只能选择一个
      if (selectedRows.length > 1) {
        this.$message.warning("转票只能选择一个报名人");
        return;
      }
      this.selectedPerson = selectedRows[0];
      this.selectRegistrantVisible = false;
      this.doTransfer();
    },
    /**
     * 选择报名人关闭
     */
    handleSelectRegistrantClose() {
      this.selectRegistrantVisible = false;
    },
    /**
     * 选择儿童确认
     */
    handleSelectChildConfirm(selectedRows) {
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning("请至少选择一个儿童");
        return;
      }
      // 转票只能选择一个
      if (selectedRows.length > 1) {
        this.$message.warning("转票只能选择一个儿童");
        return;
      }
      this.selectedPerson = selectedRows[0];
      this.selectChildVisible = false;
      this.doTransfer();
    },
    /**
     * 选择儿童关闭
     */
    handleSelectChildClose() {
      this.selectChildVisible = false;
    },
    /**
     * 执行转票操作
     */
    doTransfer() {
      if (!this.selectedPerson) {
        this.$message.error("请选择新参会人");
        return;
      }

      // 构建转票参数，根据API文档格式
      const params = {
        signUpNo: this.signNo,
        carryPeopleList: [
          {
            id: this.currentPersonId || 0,
            idCardNo: this.selectedPerson.idCardNo || "",
            isChild: this.selectedPerson.isChild || false,
            mobile: this.selectedPerson.mobile || "",
            realName: this.selectedPerson.realName || "",
            relationship: this.selectedPerson.relationship || "",
            sex: this.selectedPerson.sex || null
          }
        ]
      };

      meetingSignUpApi
        .transferTicket(params)
        .then(data => {
          this.$message.success("转票成功");
          this.selectedPerson = null;
          this.loadList();
          this.$emit("created");
        })
        .catch(error => {
          this.$message.error(error.msg || "转票失败");
        });
    },
    /**
     * 查看转票记录
     */
    handleTransferRecord(row) {
      this.currentPersonId = row.id;
      this.recordVisible = true;
      this.loadRecordList();
    },
    /**
     * 加载转票记录列表
     */
    loadRecordList() {
      if (!this.currentPersonId) {
        this.$message.error("参会人ID不能为空");
        return;
      }
      this.recordLoading = true;
      meetingSignUpApi
        .fetchTransferRecord({ id: this.currentPersonId })
        .then(res => {
          if (res && res.data) {
            this.recordList = res.data || [];
          } else {
            this.recordList = [];
          }
        })
        .catch(error => {
          this.$message.error(error.msg || "获取转票记录失败");
          this.recordList = [];
        })
        .finally(() => {
          this.recordLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.transfer-ticket-list,
.transfer-record-list {
  border: 1px solid #ebeef5;
}

.transfer-ticket-header,
.transfer-record-header {
  display: flex;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.header-cell {
  padding: 12px;
  text-align: center;
  font-weight: 600;
  color: #606266;
  border-right: 1px solid #ebeef5;
}

.header-cell:last-child {
  border-right: none;
}

.transfer-ticket-body,
.transfer-record-body {
  max-height: 500px;
  overflow-y: auto;
}

.transfer-ticket-row,
.transfer-record-row {
  display: flex;
  border-bottom: 1px solid #ebeef5;
  background-color: #fff;
}

.transfer-ticket-row.row-even,
.transfer-record-row.row-even {
  background-color: #fafafa;
}

.transfer-ticket-row:hover,
.transfer-record-row:hover {
  background-color: #f5f7fa;
}

.body-cell {
  padding: 12px;
  text-align: center;
  border-right: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.body-cell:last-child {
  border-right: none;
}

.cell-content {
  width: 100%;
  word-break: break-word;
  line-height: 1.5;
  color: #6c6c6c;
  font-size: 12px;
}

.name-info {
  color: #000f29;
  font-size: 14px;
}

.empty-data {
  text-align: center;
  padding: 40px;
  color: #909399;
}

.dialog-footer {
  text-align: right;
}
</style>
